var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fileUrl)?_c('v-img',{attrs:{"src":_vm.fileUrl}},[_c('v-overlay',{attrs:{"absolute":"","bottom":"","right":""}},[_c('v-btn',{attrs:{"large":"","icon":""},on:{"click":_vm.triggerFunction}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-play-circle-outline")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }